import type { ComponentProps } from "react";
import { useRef } from "react";
import { LuVideo } from "react-icons/lu";

import { useEditorUpload } from "@/components/app/editor-v3/use-editor-upload";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MAX_VIDEO_SIZE_BYTES } from "@/utils/constants";

import { EDITOR_MEDIA_ACCEPT, EditorMediaType } from "../constants";

export const EditorActionVideo = (props: ComponentProps<typeof Button>) => {
  const fileInputRef = useRef<HTMLInputElement>(null!);
  const { addFiles } = useEditorUpload();

  return (
    <Button {...props} onClick={() => fileInputRef.current.click()}>
      <Input
        className="hidden"
        type="file"
        accept={EDITOR_MEDIA_ACCEPT.video}
        multiple
        hidden
        ref={fileInputRef}
        onChange={async (ev) => {
          const files = ev.target.files;

          if (!files) return;

          addFiles(Array.from(files), EditorMediaType.Video, {
            maxFileSize: MAX_VIDEO_SIZE_BYTES,
          });

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        }}
      />
      <LuVideo className="text-lg" />
    </Button>
  );
};
